import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = async (payload) => {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
};

export const fetchLeads = async () => {
  const res = await axios.get(`${API}/leads`);
  return res.data;
};

export const fetchPosts = async (params = {}) => {
  const res = await axios.get(`${API}/posts`, { params });
  return res.data;
};

export const fetchPost = async (slug) => {
  const res = await axios.get(`${API}/posts/${slug}`);
  return res.data;
};
